import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteNoticeAnnouncement } from '@services/registry';

export function useDeleteNotice({ tenantId }) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: async ({ noticeId, noticeType }) => {
            return await deleteNoticeAnnouncement({ tenantId, noticeId, noticeType });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['notices', tenantId] });
        },
    });
}
